import { UserDataLevel } from 'modules/campaignAnalytics/constants';
import { useState } from 'react';
import { Button, BUTTON_SIZES, BUTTON_VARIANTS, IconButton } from 'ui/button';
import { Close16, Expand16, View16 } from 'ui/icons';
import { Tooltip } from 'ui/tooltip';
import { useDynamicHeatmapContext, useDynamicHeatmapDrawerContext } from '../../context';
import { ActionButtons, ButtonContainer, DropdownButton } from './TemplatePreview.styles';
import { UserSearch } from './UserSearch';

export const TemplatePreviewButtons = () => {
  const {
    userData,
    loadUser,
    userList,
    isFullscreen,
    setIsFullscreen,
    setUserData,
    userDataLevel,
    loadedIframe,
    setLoadedIframe,
  } = useDynamicHeatmapContext();
  const { toggle, collapse } = useDynamicHeatmapDrawerContext();
  const [userIdx, setUserIdx] = useState(-1);

  return (
    <ButtonContainer>
      {userData !== '{}' && (
        <Button
          data-test="reset-user-data-button"
          onClick={() => {
            collapse();
            setUserData('{}');
          }}
          size={BUTTON_SIZES.MEDIUM}
          variant={BUTTON_VARIANTS.GHOST}
        >
          <span>Reset</span>
        </Button>
      )}
      {userDataLevel === UserDataLevel.Dropdown ? (
        <ActionButtons>
          <DropdownButton
            data-test="heatmap-preview-button"
            $isFirst={true}
            onClick={() => {
              if (userData === '{}' || userList?.length === 1) {
                loadUser(userList[0]);
                setUserIdx(0);
              } else {
                let randomIdx = Math.floor(Math.random() * userList.length);

                while (randomIdx === userIdx) {
                  randomIdx = Math.floor(Math.random() * userList.length);
                }

                loadUser(userList[randomIdx]);
                setUserIdx(randomIdx);
              }
            }}
          >
            <View16 height={16} width={16} />
            Preview
          </DropdownButton>
          <UserSearch isEmbedded />
        </ActionButtons>
      ) : (
        <Button
          data-test="heatmap-preview-button"
          variant={BUTTON_VARIANTS.SECONDARY}
          onClick={() => toggle()}
        >
          <View16 height={16} width={16} />
          Preview
        </Button>
      )}
      <Tooltip delayDuration={600} tooltipContent={!isFullscreen ? 'Full-screen view' : 'Close'}>
        <IconButton
          data-test="fullscreen-toggle-button"
          variant={BUTTON_VARIANTS.SECONDARY}
          onClick={() => {
            window.scrollTo(0, 0);
            setIsFullscreen(!isFullscreen);
            setLoadedIframe(loadedIframe + 1);
          }}
        >
          {!isFullscreen ? <Expand16 /> : <Close16 />}
        </IconButton>
      </Tooltip>
    </ButtonContainer>
  );
};
